<template lang="pug">
.overlay.overlay-login
  AppLink(to="/" :title="$t('close')" class="overlay-close") #[AppIcon(name='close')]
  .overlay-body.u-mh-md
    .container
      RegisterForm
</template>

<script>
import { generateSeoMeta } from '~/utils/seo';
import RegisterForm from '~/components/forms/RegisterForm';

export default {
  transition: 'overlay',
  middleware: 'guest',
  head() {
    const seo = generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true }).call(this);

    return {
      ...seo,
      bodyAttrs: {
        class: 'is-scroll-disabled'
      }
    };
  },
  components: {
    RegisterForm
  },
  data: () => ({
    method: null
  }),
  methods: {
    onSuccess() {
      this.$router.localePush('/cc');
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle": "Register",
    "pageDesc": "Sign Up a Baianat Account"
  },
  "ar": {
    "pageTitle": "انشاء حساب",
    "pageDesc": "سجل دخول لحسابك في بيانات"
  }
}
</i18n>
